import React from 'react';
import { Section } from '@fiverr-private/layout_components';
import { Heading, Text } from '@fiverr-private/typography';

interface ProfessionCategoryHeaderProps {
    seoData: {
        localizedHeading: string;
        localizedTagline: string;
    };
}

export const ProfessionCategoryHeader: React.FC<ProfessionCategoryHeaderProps> = ({ seoData }) => {
    const { localizedHeading, localizedTagline } = seoData;

    if (!localizedHeading || !localizedTagline) {
        return null;
    }

    return (
        <Section paddingBottom="0">
            <Heading size="h_md">{localizedHeading}</Heading>
            <Text color="bodySecondary">{localizedTagline}</Text>
        </Section>
    );
};
